import { IPersonalBonusCode } from "@interfaces/user/bonusCodes";
import { createContext, useContext } from "react";

const PersonalCodeContext = createContext<IPersonalBonusCode>(undefined as any);
export const PersonalCodeProvider = PersonalCodeContext.Provider;

export function usePersonalCodeContext(): IPersonalBonusCode | undefined {
    return useContext(PersonalCodeContext);
}